import Web3 from "web3";

import { abi as ProtokolABI } from "../abi/ProtokolABI.json";
import { abi as ERC20ABI } from "../abi/ERC20Abi.json";
import * as uiTypes from "../../redux/types/uiTypes";

import { PROTOKOL_CONTRACT_ADDRESS } from "../constants";

let web3;

let protokolContract;

export const initializeWeb3 = async (
  contractAddress,

  provider
) => {
  // console.log("xxxxxxxxxxxx changed xxxxxxxxxxx", provider);

  web3 = new Web3(provider);

  // erc20Contract = new web3.eth.Contract(abi, tokenAddress);

  protokolContract = new web3.eth.Contract(ProtokolABI, contractAddress);

  // console.log("addresses => ", {
  //   contractAddress,
  //   methods: protokolContract.methods,
  // });
};

let erc20Contract;
// let web3;
export const approveToken = async (
  tokenAddress,
  contractAddress,
  sourceAddress
) => {
  // web3 = new Web3(provider);

  try {
    erc20Contract = new web3.eth.Contract(ERC20ABI, tokenAddress);
    let response = await erc20Contract.methods
      .approve(contractAddress, web3.utils.toWei("1000000000"))
      .send({ from: sourceAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
        }
      });
    console.log("approveToken response => ", response);
  } catch (error) {
    console.log("Error => ", error);
  }
};

export const checkApproval = async (
  tokenAddress,
  contractAddress,
  sourceAddress
) => {
  try {
    erc20Contract = new web3.eth.Contract(ERC20ABI, tokenAddress);
    console.log("ERC", erc20Contract);
    let response = await erc20Contract.methods
      .allowance(sourceAddress, contractAddress)
      .call();
    console.log("checkApproval response => ", response);
    return Number(response);
  } catch (error) {
    console.log("Error => ", error);
  }
};

// No.of campaigns created by Project
export const campaignCounts = async (address) => {
  console.log("campaignCounts => ", {
    address,
    protokolContract,
  });
  try {
    let response = await protokolContract.methods
      .campaignCounts(address)
      .call();

    console.log("campaignCounts response => ", response);
  } catch (error) {
    console.log("campaignCounts error => ", error);
  }
};

export const campaignKols = async (campaignId) => {
  console.log("campaignKols => ", {
    campaignId,
  });
  try {
    let response = await protokolContract.methods
      .campaignKols(campaignId)
      .call();

    console.log("campaignKols response => ", response);
  } catch (error) {
    console.log("campaignKols error => ", error);
  }
};

export const campaigns = async (projectId) => {
  console.log("campaigns => ", {
    projectId,
  });
  try {
    let response = await protokolContract.methods.campaigns(projectId).call();

    console.log("campaigns response => ", response);
  } catch (error) {
    console.log("campaigns error => ", error);
  }
};

export const isCampaignKOL = async (campaignId) => {
  console.log("isCampaignKOL => ", {
    campaignId,
  });
  try {
    let response = await protokolContract.methods
      .isCampaignKOL(campaignId)
      .call();

    console.log("isCampaignKOL response => ", response);
  } catch (error) {
    console.log("isCampaignKOL error => ", error);
  }
};

export const isKOL = async (kolId) => {
  console.log("isKOL => ", {
    kolId,
  });
  try {
    let response = await protokolContract.methods.isKOL(kolId).call();

    console.log("isKOL response => ", response);
  } catch (error) {
    console.log("isKOL error => ", error);
  }
};

export const isProjectOwner = async (projectId) => {
  console.log("isProjectOwner => ", {
    projectId,
  });
  try {
    let response = await protokolContract.methods
      .isProjectOwner(projectId)
      .call();

    console.log("isProjectOwner response => ", response);
  } catch (error) {
    console.log("isProjectOwner error => ", error);
  }
};

export const kols = async (campaignId) => {
  console.log("kols => ", {
    campaignId,
  });
  try {
    let response = await protokolContract.methods.kols(campaignId).call();

    console.log("kols response => ", response);
  } catch (error) {
    console.log("kols error => ", error);
  }
};

// export const registerProject = async (campaignId) => {
//   console.log("projects => ", {
//     campaignId,
//   });
//   try {
//     let response = await protokolContract.methods.registerProject(campaignId).call();

//     console.log("projects response => ", response);
//   } catch (error) {
//     console.log("projects error => ", error);
//   }
// };

export const investInCampaign = async (
  walletAddress,
  investmentId,
  campaignId,
  budget,
  followers,
  investAmount,
  dispatch
) => {
  console.log("investInCampaign web3.utils.toWei(investAmount)=> ", {
    walletAddress,
    investmentId,
    campaignId,
    budget,
    followers,
    investAmount,
  });
  try {
    const qqqqqqq = web3.utils.toWei(investAmount.toString());
    console.log({ qqqqqqq });
    let response = await protokolContract.methods
      .investInCampaign(
        investmentId,
        [campaignId, budget * 10 ** 6, followers, walletAddress, true],
        investAmount * 10 ** 6
      )
      .send({ from: walletAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          dispatch({
            type: uiTypes.SET_LOADING,
            payload: false,
          });
        }
      })
      .on("error", (err) => {
        dispatch({
          type: uiTypes.SET_LOADING,
          payload: false,
        });
        // dispatch(
        //   setShowSnackbar({
        //     open: true,
        //     message: "Transaction Failed",
        //   })
        // );
      });

    console.log("investInCampaign response => ", response);
  } catch (error) {
    console.log("investInCampaign error => ", error);
    dispatch({
      type: uiTypes.SET_LOADING,
      payload: false,
    });
  }
};

export const depositToken = async (
  walletAddress,
  projectId,
  // tokenAddress,
  tokenAmount,
  callbackFunction
) => {
  console.log("depositToken => ", {
    walletAddress,
    projectId,
    // tokenAddress,
    tokenAmount,
  });
  try {
    let response = await protokolContract.methods
      .depositTokens(projectId, web3.utils.toWei(tokenAmount))
      .send({
        from: walletAddress,
        value: web3.utils.toWei(tokenAmount),
      })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          callbackFunction();
        }
      });

    console.log("depositToken response => ", response);
  } catch (error) {
    console.log("depositToken error => ", error);
  }
};

export const withdrawReward = async (
  walletAddress,
  campaignId,
  withdrawValue,
  callbackFunction
) => {
  console.log("withdrawReward => ", {
    walletAddress,
    campaignId,
    withdrawValue,
  });
  try {
    let response = await protokolContract.methods
      .withdrawReward(campaignId, web3.utils.toWei(withdrawValue.toString()))
      .send({ from: walletAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          callbackFunction();
        }
      });

    console.log("withdrawReward response => ", response);
  } catch (error) {
    console.log("withdrawReward error => ", error);
  }
};

export const withdrawFundsProj = async (
  walletAddress,
  campaignId,
  withdrawAmount,
  callbackFunction
) => {
  console.log("withdrawFundsProj => ", {
    walletAddress,
    campaignId,
    withdrawAmount,
  });
  try {
    let response = await protokolContract.methods
      .withdrawFunding(campaignId, parseInt(withdrawAmount) * 10 ** 6)
      .send({ from: walletAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          callbackFunction();
        }
      })
      .on("error", (error) => {
        console.log("Error a giyaa yayyyyyyyyyyyyyy");
      });
    console.log("withdrawFundsProj response => ", response);
  } catch (error) {
    console.log("withdrawFundsProj error => ", error);
  }
};

export const acceptMarketing = async (
  walletAddress,
  investmentId,
  rewardAmount
) => {
  console.log("acceptMarketing => ", {
    walletAddress,
    investmentId,
    rewardAmount,
  });
  try {
    let response = await protokolContract.methods
      .acceptMarketing(walletAddress, investmentId, rewardAmount)
      .send({ from: walletAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        // if (confirmationNumber === 1) {
        //   console.log("acceptMarketing confirmationNumber => ", {
        //     confirmationNumber,
        //     receipt,
        //   });
        // }
      });

    console.log("acceptMarketing response => ", response);
  } catch (error) {
    console.log("acceptMarketing error => ", error);
  }
};

export const releaseFundsToInvestors = async (
  campaignId,
  campaignKols,
  sourceAddress
) => {
  console.log("releaseFundsToInvestors => ", {
    campaignId,
    campaignKols,
    sourceAddress,
  });
  try {
    let response = await protokolContract.methods
      .releaseFundsToInvestors(campaignId, campaignKols)
      .send({ from: sourceAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          console.log("releaseFundsToInvestors confirmationNumber => ", {
            confirmationNumber,
            receipt,
          });
        }
      });

    console.log("releaseFundsToInvestors response => ", response);
  } catch (error) {
    console.log("releaseFundsToInvestors error => ", error);
  }
};

export const registerCampaign = async (
  campaignId,
  sourceAddress,
  projectId,
  followersNeeded,
  followersDone,
  budget,
  boolActive,
  callbackFunction,
  dispatch
) => {
  console.log("registerCampaign => ", {
    campaignId,
    projectId,
    followersNeeded,
    followersDone,
    budget,
    boolActive,
    sourceAddress,
  });
  try {
    let response = await protokolContract.methods
      .registerCampaign(campaignId, [
        projectId,
        followersNeeded,
        followersDone,
        budget,
        boolActive,
      ])
      .send({ from: sourceAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          console.log("HASAN NHY CHALA");
          callbackFunction();
          dispatch({
            type: uiTypes.SET_LOADING,
            payload: false,
          });
        }
      });

    console.log("registerCampaign response => ", response);
  } catch (error) {
    console.log("registerCampaign error => ", error);
    dispatch({
      type: uiTypes.SET_LOADING,
      payload: false,
    });
  }
};

export const registerKOL = async (
  walletAddress,
  kolId,
  callbackFunction,
  dispatch
) => {
  console.log("registerKOL => ", {
    walletAddress,
  });
  try {
    let response = await protokolContract.methods
      .registerKOL()
      .send({ from: walletAddress })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          callbackFunction();
          dispatch({
            type: uiTypes.SET_LOADING,
            payload: false,
          });
        }
      })
      .on("error", (error) => {
        callbackFunction(kolId);
      });

    // console.log("registerKOL response => ", response);

    return response;
  } catch (error) {
    // console.log("registerKOL error => ", error);
    dispatch({
      type: uiTypes.SET_LOADING,
      payload: false,
    });
    return error;
  }
};
export const registerProject = async (
  projectID,
  projectOwner,

  marketingBudget,
  maxTokenSupply,
  initialCirculatingSupply,
  preSaleTokenPrice,
  tokenLaunchPrice,
  callbackFunction,
  dispatch
) => {
  console.log("registerProject => ", {
    projectID,
    projectOwner,

    marketingBudget,
    maxTokenSupply,
    initialCirculatingSupply,
    preSaleTokenPrice,
    tokenLaunchPrice,
  });
  try {
    let response = await protokolContract.methods
      .registerProject(projectID, [
        projectOwner,

        web3.utils.toWei(marketingBudget.toString()),
        web3.utils.toWei(maxTokenSupply.toString()),
        web3.utils.toWei(initialCirculatingSupply.toString()),
        web3.utils.toWei(preSaleTokenPrice.toString()),
        web3.utils.toWei(tokenLaunchPrice.toString()),
      ])
      .send({ from: projectOwner })
      .on("transactionHash", (hash) => {})
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 1) {
          dispatch({
            type: uiTypes.SET_LOADING,
            payload: false,
          });
          callbackFunction();
        }
      })
      .on("error", (error) => {
        callbackFunction(projectID);
      });

    // console.log("registerProject response => ", response);
    return response;
  } catch (error) {
    // console.log("registerProject error => ", error);
    dispatch({
      type: uiTypes.SET_LOADING,
      payload: true,
    });
    return error;
  }
};
